import { DailyStep } from "../../types/DailyStep";
import DB_PATH from "../DB_PATH";
import firebase from "../firebase";

export const updateDailyStep = async ({
  dailyStep,
}: {
  dailyStep: DailyStep;
}) => {
  try {
    const firestore = firebase.firestore();
    await firestore
      .collection(DB_PATH.PLAN_STEP)
      .doc(dailyStep.id)
      .set(dailyStep, { merge: true }); // Using merge to update only provided fields
  } catch (error) {
    console.error("Error updating daily step:", error);
  }
};
